import { render } from "./ComissaoFilters.vue?vue&type=template&id=9a58a79e"
import script from "./ComissaoFilters.vue?vue&type=script&lang=js"
export * from "./ComissaoFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__